import { render } from "./informe21.vue?vue&type=template&id=283223f7"
import script from "./informe21.vue?vue&type=script&lang=js"
export * from "./informe21.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/NewMov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__